import Grid from '@mui/material/Grid'

import AccordionActionsButtons from '../common/accordianAction'
import { ClientProps } from './form'
import { useCallback, useEffect, useState } from 'react'
import { getClientContacts } from '../../helper'
import TextfieldAsyncSearchHook from '../../../../molecules/textfield-async-search/textfieldAsyncSearchHook'
import { CLIENT_TYPES } from '../../../../constants/project.constants'
import { useOptionsFetch } from '../../../../utils/hooks/useOptionsFetch'
import { APIRoutes } from '../../../../constants'
import { isAdmin, isSuperAdmin } from '../../../../utils/role'

type Props = { handleReset: () => void }

const Fields = ({ handleReset }: Props) => {
    const [filterOptions, setFilterOptions] = useState<any[]>([]);
    const [clientTypes, setClientTypes] = useState<any[]>([]);
    const [clientsOptions, setClientsOptions] = useState<any[]>([]);
    const {
        apiData: clientsList,
    } = useOptionsFetch(APIRoutes.clients);
    const getClientsOptions = useCallback((inputValue: string) => {
        if (inputValue?.length < 3) {
            return;
        }
        const options = clientsList?.filter((client) => client?.label?.toLowerCase()?.includes(inputValue?.toLowerCase()));
        const limitedOptions = options?.slice(0, 50);
        return limitedOptions;
    }, [clientsList])

    const getFilteredClientTypeOptions = useCallback((inputValue: string) => {
        const clientTypeOptions = Object.values(CLIENT_TYPES)?.map((type) => ({ label: type, value: type }));
        if (inputValue?.length === 0) {
            return clientTypeOptions;
        }
        return clientTypeOptions?.filter((option) => option?.label?.toLowerCase()?.includes(inputValue?.toLowerCase()));
    }, [])
    useEffect(() => {
        setClientTypes(getFilteredClientTypeOptions(''));
    }, [])

    const isClientFilterVisible: boolean = isSuperAdmin() || isAdmin();

    return (
        <>
            <Grid container spacing={2}>
                {isClientFilterVisible ? (
                    <>
                        <Grid item xs={12}>
                            <TextfieldAsyncSearchHook
                                registerStatename="client_type"
                                options={clientTypes}
                                searchFunction={(inputValue: string) => getFilteredClientTypeOptions(inputValue)}
                                setOptions={(state: any) =>
                                    setClientTypes([...state])
                                }
                                label="Client Type"
                                multi={true}
                                isRequired={false}
                                inputLength={1}
                                disableCloseOnSelect={true}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextfieldAsyncSearchHook
                                registerStatename="fk_client"
                                options={clientsOptions}
                                searchFunction={(inputValue: string) => getClientsOptions(inputValue)}
                                setOptions={(state: any) =>
                                    setClientsOptions([...state])
                                }
                                label="Client"
                                multi={true}
                                isRequired={false}
                                inputLength={3}
                                disableCloseOnSelect={true}
                            />
                        </Grid>
                    </>
                ) : (<></>)}
                <Grid item xs={12}>
                    <TextfieldAsyncSearchHook
                        registerStatename="client_contacts"
                        options={filterOptions}
                        searchFunction={(inputValue: string) => getClientContacts(inputValue)}
                        setOptions={(state: any) =>
                            setFilterOptions([...state])
                        }
                        label="Client Contacts"
                        multi={true}
                        isRequired={false}
                        disableCloseOnSelect={true}
                    />
                </Grid>
            </Grid>
            <AccordionActionsButtons
                clearAllAction={handleReset}
                selectAllAction={() => { }}
                checkedLength={1}
            />
        </>
    )
}

export default Fields